import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { useNavigate } from 'react-router-dom'


const RenderInspact = () => {

const awsurl=sessionStorage.getItem("AWS_URL");
const resturl=sessionStorage.getItem("REST_URL");

const navigate = useNavigate();



const handleInspActChange = (e) => {
//destructure an array of objects in JavaScript
const {name, value}=e.target;

	setInspact((prev) => {
	return {...prev, [name]:value}
	},console.log('inspact.INF: '+inspact.INF) )};  

const [tblinspacts, setTblinspacts] = useState({
 htm:null
});

const [criteria, setCriteria]=useState({
OP_DATE_TIME:''
,SAD_SID:''
});



const [inspact, setInspact] = useState({
INSTANCE_ID: ''
,op_date:''
,SAD_SID:''
,SAD_REG_SER: ''
,SAD_REG_NBR: ''
,SAD_REG_DAT: ''
,SAD_AST_SER: ''
,SAD_AST_NBR: ''
,SAD_AST_DAT: ''
,SAD_DEC_REF_YEA: ''
,SAD_DEC_REF_NBR: ''
,SAD_DEC_COD: ''
,SAD_DEC_NAM: ''
,SAD_MOD: ''
,IDE_CUO_COD: ''
,IDE_CUO_NAM: ''
,INF: ''
,PTY_FRM_NBR: ''
,PTY_FRM_TOT: ''
,PTY_NBR_LDL: ''
,SAD_AMT_REV: ''
,SAD_AMT_RFD: ''

});








const location = useLocation();


useEffect(() => {
	
	if (sessionStorage.getItem("AW_USERNAME")==null){
	navigate("../logout");
	return;
	}
	
	let INSP_ACT_INSTANCE_ID= 0 ;

	if (location.state)
		if (location.state.INSP_ACT_INSTANCE_ID)
			INSP_ACT_INSTANCE_ID=location.state.INSP_ACT_INSTANCE_ID;

console.log('RenderInspact! location.state.INSP_ACT_INSTANCE_ID: '+INSP_ACT_INSTANCE_ID);
/*
	
	console.log('RenderInspact! inspact.INSTANCE_ID: '+inspact.INSTANCE_ID);
	const flagSetInspact=(inspact.INSTANCE_ID!=location.state.INSP_ACT_INSTANCE_ID);
	console.log('RenderInspact! flagSetInspact: '+flagSetInspact);

*/
	if (inspact.INSTANCE_ID==0 && INSP_ACT_INSTANCE_ID>0){
		fetchInspAct(INSP_ACT_INSTANCE_ID);
		//setInspact({...inspact, INSTANCE_ID:INSP_ACT_INSTANCE_ID});
		}//end if
	//else
		fetchTblinspacts(0, '');
	  },[]);



  const handleFocus = (e) => {
  //e.target.blur();
  if (e.target.readOnly)
	e.target.style.background='gainsboro';
/*
else 
	e.target.select();
*/
	e.target.select();

	}//end func

function fetchTblinspacts(instance_id, op_date){
	

console.log('fetchtblinspacts instance_id, op_date: '+instance_id+', '+op_date);

if (instance_id=='')
	document.getElementsByName("regNbr")[0].value='';


setTblinspacts({
htm:<><tr key='trwait' ><td align='center' colSpan='8' ><img src='img/Loading_2.gif' border='0' height='36' /> loading inspection acts </td></tr></>
});
//setInstanceid(instance_id);

/*
if (instance_id=='')
	window.alert('Inspection act was not created');

*/

const params={
INSTANCEID: instance_id
,OP_DATE: op_date
}//end function

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarinspact/gettblinspacts',requestOptions)
      .then(res => res.json())
      .then(res => frmtblinspacts(res))
      .catch(err => console.log(err));
	  

}//end func  

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func


function aftersendtoaws(res, args, instanceid, seqno){

console.log('aftersendtoaws res:'+res);


console.log(JSON.stringify(res));


if (res.op=="inspection-act"){
	showsnackbar('validate complete');
	document.getElementById('btnvalidate').style.display='block';
	document.getElementById('waiticon').style.display='none';
	}
	
	
}//end func

function fetchInspAct(instance_id){
console.log('fetchInspAct instance_id: '+instance_id);
//setInstanceid(instance_id);

if (instance_id=='' || instance_id==undefined){
	console.log('Inspection act was not created');
	return;
	}
	

const params={
INSTANCE_ID: instance_id
}//end function

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarinspact/getinspact',requestOptions)
      .then(res => res.json())
      .then(res => frminspact(res))
      .catch(err => console.log(err));
	  

}//end func  


function showHideForm(flag){
if (flag==1){
	document.getElementById('InspectionAct').classList.add('inspactform');
	document.getElementById('InspectionAct').style.display='block';
	document.getElementById('tblinspacts').style.display='none';
	}
else if (flag==0){
	var INSP_ACT_INSTANCE_ID=0;
	
	if (location.state!=null)
		if (location.state.INSP_ACT_INSTANCE_ID!=undefined)
			INSP_ACT_INSTANCE_ID=location.state.INSP_ACT_INSTANCE_ID;
		
	
	if (INSP_ACT_INSTANCE_ID>0){
		const state={
					sad_payment_groupid: location.state.sad_payment_groupid
					,instanceid: location.state.instanceid
					,fetchinstanceid: location.state.instanceid
					};
		console.log('state: '+JSON.stringify(state));

		navigate(`/sad`,{state:state});
		}//end if
	else{
		document.getElementById('InspectionAct').classList.remove('inspactform');
		document.getElementById('InspectionAct').style.display='none';
		document.getElementById('tblinspacts').style.display='block';
		}//end else
	
	}//end else
	
}//enc

function frminspact(res){

/*
frminspact will set the inspact.INSTANCE_ID 
and inspact had a useEffect to fetchInspAct, hence infinite loop.
solution: frminspact must do setInspact
hence on add condition if (attributename!='INSTANCE_ID'), so does not set INSTANCE_ID
and set the useEffect to inspact.INSTANCE_ID instead of inspact

I deleted the useEffect to inspact.INSTANCE_ID and removed the condition that was below if (attributename!='INSTANCE_ID')

*/

var datas={};
//console.log("res[0].length: "+res[0].length); 
for(var attributename in inspact){
		datas[attributename] = res[0][attributename];
	}//end for

showHideForm(1);

//var jsonData=JSON.stringify(datas);
//console.log("datas: "+JSON.stringify(datas)); 

setInspact(datas);

const opdate=document.getElementsByName('opdate')[0].value;

/*
if (res[0].SAD_AST_DAT_RAW!=opdate){
	const astDat = res[0].SAD_AST_DAT_RAW;
	console.log("frminspact setting opdate to: "+astDat); 
	document.getElementsByName('opdate')[0].value=astDat;
	fetchTblinspacts(0, astDat);
	}

*/
	

//console.log("inspact.SAD_DEC_COD: "+inspact.SAD_DEC_COD); 


return false;
}//end function	 


function sendtoaws(args, instanceid, seqno){
	
	const url= awsurl + "instanceid="+instanceid+"&seqno="+seqno+"&"+args;

	console.log('url: '+url);
	fetch(url,{method: 'GET'})
	.then(res => res.json() )
	.then(res => aftersendtoaws(res, args, instanceid, seqno) )
	.catch(err => console.log(err));  
	
	  
}//end func

function openCity(city){
	console.log('openCity: '+city);
}


function getsadseqno(){

document.getElementById('btnvalidate').style.display='none';
document.getElementById('waiticon').style.display='block';

console.log('getsadseqno instanceid: '+inspact.SAD_SID);
const instanceid=inspact.SAD_SID;
//username+"', 0"+req.body.INSTANCEID
const params={
username: sessionStorage.getItem("AW_USERNAME")
, INSTANCEID: inspact.SAD_SID

}//end function

//console.log(JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

console.log('next: call rarsad/getseqno');

  fetch(resturl+'rarsad/getseqno',requestOptions)
      .then(res => res.json())
      .then(res => aftergetseqno(res, instanceid))
      .catch(err => console.log(err));
	  
return false;
}//end function

function aftergetseqno(res, instanceid){
console.log('aftergetseqno SEQNO: '+res[0].SEQNO);
const seqNo = res[0].SEQNO;
const params={
 INSTANCEID: instanceid
, SEQNO: seqNo
, INSP_ACT_INSTANCE_ID: inspact.INSTANCE_ID
, INF: inspact.INF
}//end function

console.log('aftergetseqno inspact.INSTANCE_ID: '+inspact.INSTANCE_ID);
console.log('aftergetseqno params: '+JSON.stringify( params ));



    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };



  fetch(resturl+'rarinspact/senddatatodb',requestOptions)
      .then(res => res.json())
      .then(res => aftersenddatatodb(res, instanceid, seqNo))
      .catch(err => console.log(err));



}//end function

function setSadFilter(e){
e.preventDefault();
document.getElementsByName("regNbr")[0].value=inspact.IDE_CUO_COD+' '+inspact.SAD_DEC_REF_YEA+' '+inspact.SAD_REG_SER+' '+inspact.SAD_REG_NBR
console.log('setSadFilter inspact.SAD_SID: '+inspact.SAD_SID);
fetchTblinspacts(inspact.SAD_SID, '');
showHideForm(0);
//setCriteria({SAD_SID:inspact.SAD_SID});
}

function aftersenddatatodb(res, instanceid, seqNo){
console.log('aftersenddatatodb INF_LENGTH: '+res[0].INF_LENGTH);	
sendtoaws('op=inspection-act', instanceid, seqNo);
}//end function

function frmtblinspacts(res){
console.log('frmtblinspacts: '+res[0].error);
let htmrows=[];
let P_OP_DATE_TIME='';
var rownum=1;
if (res[0].error==undefined)
res.map((col, index) => {
		
		if (P_OP_DATE_TIME=='')
			P_OP_DATE_TIME=col['P_OP_DATE_TIME'];
		const key='tblinspacts'+index;
		
	htmrows.push(<tr key={key} >
		<td align="right" >{rownum}</td>
		<td align="center" >{col['OP_DATE_TIME']}</td>
		<td align="left" >{col['FULLNAME']}</td>
		<td align="right" >{col['SAD_AMT_REV']}</td>
		<td align="left" ><a href="#" onClick={(e)=>{e.preventDefault();   fetchInspAct(col['INSTANCE_ID'])}} >open</a></td>
		<td align="left" title={col['INF']} >{col['SHORT_INF']}</td>
		<td align="left" >{col['SAD_DEC_REF_NBR']}</td>
		<td align="left" >{col['SAD_DEC_NAM']}</td>
		</tr>
	);
	rownum++;
	}//end for
	);
else	
	htmrows.push(<tr key='tblinspactserr' ><td align="center" colSpan="8" >{res[0].error}</td></tr>);
	//console.log("rownum: "+rownum); 
//console.log("datas: "+JSON.stringify(htmrows)); 
const opdate = document.getElementsByName('opdate')[0].value;
if (opdate==null || opdate=='')
	document.getElementsByName('opdate')[0].value=P_OP_DATE_TIME;
setTblinspacts({htm:htmrows});
//,()=>{console.log("htm: "+tblinspacts.htm); }
//openCity(null,"Inspacts");


}//end function	

  return (
    <>

<div align="center" id="tblinspacts" >
	   <div align="center" style={{"marginTop":"18px","marginBottom":"18px"}} >
	   Inspection Acts Date: <input type="date" name="opdate" onChange={(e)=>{ e.preventDefault(); fetchTblinspacts(0, e.target.value); }} />
	   <br/>
	   Declaration Filter: <input type="text" name="regNbr" readOnly className="grey" />
	   </div>
	   
	   <div align="center" style={{"width":"85%","marginLeft":"auto","marginRight":"auto"}} >
	   <table align="center" className="customers" >
	   <thead>
	   <tr>
	   <th align='left' >#</th>
	   <th align='left' >DATE</th>
	   <th align='left' >OFFICER</th>
	   <th align='left' >REVENUE</th>
	   <th align='left' >&nbsp;</th>
	   <th align='left' >INFO</th>
	   <th align='left' >DEC. REF #</th>
	   <th align='left' >DECLARANT</th>

	   </tr>
	   </thead>
		<tbody>
		{tblinspacts.htm}
		</tbody>
		</table>
		</div>
</div>	   


      <div id="InspectionAct" style={{"display":"none"}}  >
        <img src="img/un.broker.inspact.client.VP_InspAct.png" className="inspactimg" />
		
		<a href="#" title='validate inspection act' id="btnvalidate"  onClick={(e) => { e.preventDefault(); getsadseqno()  }} style={{"position":"absolute", "left":"640px", "top":"550px", "textDecoration":"none"}} ><img src='img/Btn_OK_Normal.gif' border="0" /> validate inspection act</a>
		<div id="waiticon" style={{"position":"absolute", "left":"640px", "top":"550px", "display":"none"}} ><img src='img/Loading_2.gif' border="0" height="32" />. . . please wait</div>
		<div id='snackbar' ></div>
		
		<a href="#" title='close inspection act window'  onClick={(e) => { e.preventDefault(); showHideForm(0); }} style={{"position":"absolute", "left":"640px", "top":"50px", "textDecoration":"none"}} ><img src='img/redletterx.png' border="0" /> close inspection act window</a>
		

		<input type="text" name="Fld_CuoCod" defaultValue={inspact.IDE_CUO_COD} readOnly  onFocus={handleFocus} title="Customs Office Code" style={{"position":"absolute", "zIndex":"3", "left":"140px", "top":"55px", "width":"50px", "height":"20px"}} className="input_field" />
		<input type="text" name="Fld_CuoNam" defaultValue={inspact.IDE_CUO_NAM} readOnly  onFocus={handleFocus} title="Customs Office Name" style={{"position":"absolute", "zIndex":"3", "left":"200px", "top":"55px", "width":"240px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecCod" defaultValue={inspact.SAD_DEC_COD} readOnly  onFocus={handleFocus} title="Declarant code" style={{"position":"absolute", "zIndex":"1", "left":"30px", "top":"120px", "width":"150px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecNam" defaultValue={inspact.SAD_DEC_NAM} readOnly  onFocus={handleFocus} title="Declarant name" style={{"position":"absolute", "zIndex":"2", "left":"30px", "top":"160px", "width":"300px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegSer" defaultValue={inspact.SAD_REG_SER} readOnly  onFocus={handleFocus} title="Customs reference serial letter" style={{"position":"absolute", "zIndex":"3", "left":"580px", "top":"160px", "width":"20px", "height":"20px"}} className="input_field" />
		<img src="img/Btn_Search_Normal.gif" className="pointer" onClick={(e)=>{setSadFilter(e);}} style={{"position":"absolute", "zIndex":"4", "left":"545px", "top":"160px"}} />
        <input type="text" name="Fld_RegNbr" defaultValue={inspact.SAD_REG_NBR} readOnly  onFocus={handleFocus} title="Customs reference number" style={{"position":"absolute", "zIndex":"4", "left":"610px", "top":"160px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_RegDat" defaultValue={inspact.SAD_REG_DAT} readOnly  onFocus={handleFocus} title="Customs reference date" style={{"position":"absolute", "zIndex":"5", "left":"790px", "top":"160px", "width":"110px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecRefYea" defaultValue={inspact.SAD_DEC_REF_YEA} readOnly  onFocus={handleFocus} title="Declaration reference year" style={{"position":"absolute", "zIndex":"6", "left":"30px", "top":"200px", "width":"50px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecRefNbr" defaultValue={inspact.SAD_DEC_REF_NBR} readOnly  onFocus={handleFocus} title="Declaration reference number" style={{"position":"absolute", "zIndex":"7", "left":"100px", "top":"200px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Mod" defaultValue={inspact.SAD_MOD} readOnly  onFocus={handleFocus} title="Model" style={{"position":"absolute", "zIndex":"8", "left":"380px", "top":"200px", "width":"40px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Itm" defaultValue={inspact.SAD_ITM} readOnly  onFocus={handleFocus} title="Items" style={{"position":"absolute", "zIndex":"9", "left":"440px", "top":"200px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AstSer" defaultValue={inspact.SAD_AST_SER} title="Assessment serial letter" style={{"position":"absolute", "zIndex":"10", "left":"580px", "top":"200px", "width":"20px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AstNbr" defaultValue={inspact.SAD_AST_NBR} readOnly  onFocus={handleFocus} readOnly  onFocus={handleFocus} title="Assessment number" style={{"position":"absolute", "zIndex":"11", "left":"610px", "top":"200px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_AstDat" defaultValue={inspact.SAD_AST_DAT} readOnly  onFocus={handleFocus} title="Assessment date" style={{"position":"absolute", "zIndex":"12", "left":"790px", "top":"200px", "width":"110px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam1" title="Fraud description 1" style={{"position":"absolute", "zIndex":"13", "left":"110px", "top":"260px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="checkbox" name="Fld_Cfm" title="Conform flag" style={{"position":"absolute", "zIndex":"14", "left":"700px", "top":"260px", "width":"20px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam2" title="Fraud description 2" style={{"position":"absolute", "zIndex":"15", "left":"110px", "top":"290px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AmtRev" defaultValue={inspact.SAD_AMT_REV} readOnly  onFocus={handleFocus} title="Loss of revenue" style={{"position":"absolute", "zIndex":"16", "left":"700px", "top":"290px", "width":"150px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam3" title="Fraud description 3" style={{"position":"absolute", "zIndex":"17", "left":"110px", "top":"320px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AmtRfd" defaultValue={inspact.SAD_AMT_RFD} readOnly  onFocus={handleFocus} title="Refund" style={{"position":"absolute", "zIndex":"18", "left":"700px", "top":"320px", "width":"150px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam4" title="Fraud description 4" style={{"position":"absolute", "zIndex":"19", "left":"110px", "top":"350px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam5" title="Fraud description 5" style={{"position":"absolute", "zIndex":"20", "left":"110px", "top":"380px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam6" title="Fraud description 6" style={{"position":"absolute", "zIndex":"21", "left":"110px", "top":"410px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_PenAmt" title="Penalty amount" style={{"position":"absolute", "zIndex":"22", "left":"30px", "top":"470px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_PenRef" title="Penalty reference" style={{"position":"absolute", "zIndex":"23", "left":"230px", "top":"470px", "width":"360px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_PenDat" title="Penalty date" style={{"position":"absolute", "zIndex":"24", "left":"630px", "top":"470px", "width":"110px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DisRef" title="Disputed claims reference" style={{"position":"absolute", "zIndex":"25", "left":"230px", "top":"510px", "width":"360px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_DisDat" title="Disputed claims date" style={{"position":"absolute", "zIndex":"26", "left":"630px", "top":"510px", "width":"110px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Cri1" title="Criteria 1" style={{"position":"absolute", "zIndex":"27", "left":"30px", "top":"550px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Cri2" title="Criteria 2" style={{"position":"absolute", "zIndex":"28", "left":"230px", "top":"550px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Cri3" title="Criteria 3" style={{"position":"absolute", "zIndex":"29", "left":"430px", "top":"550px", "width":"160px", "height":"20px"}} className="input_field" />
        <textarea name="INF" defaultValue={inspact.INF} onChange={handleInspActChange} title="Information" style={{"position":"absolute", "zIndex":"30", "left":"30px", "top":"600px", "width":"880px", "height":"70px"}} className="input_field" ></textarea>
	  </div>

    </>
  );
};

export default RenderInspact;